import React from 'react';

export function VerifyingAccess() {
  return (
    <div className="space-y-4">
      <div className="text-center">
        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600 mr-2"></div>
        <span className="text-sm text-gray-600">Verifying...</span>
      </div>
    </div>
  );
} 